export default __webpack_public_path__ + "static/001-7a2d76e6b8455676b8ee0f33e623cd6c.jpg";